<template>
  <label class="btn__switch">
    <input
      type="checkbox"
      v-bind="$attrs"
      v-bind:checked="checked"
      v-on:change="$emit('change', $event.target.checked)"
    />
    <div class="btn__switch__slider btn__switch__slider--round"></div>
  </label>
</template>

<script>
export default {
  name: 'SwitchCheckbox',
  model: {
    prop: 'checked',
    event: 'change',
  },
  props: {
    checked: Boolean,
  },
}
</script>
<style lang="scss" scoped>
.btn__switch {
  display: inline-block;
  height: 20px;
  position: relative;
  width: 40px;
  padding: 5px;
  input {
    display: none;
  }
  &__slider {
    background-color: var(--emperor-gray);
    bottom: 0;
    cursor: pointer;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    transition: 0.4s;
    &:hover {
      box-shadow: 0px 4px 40px rgba(255, 255, 255, 0.4);
    }
    &:before {
      background-color: #222222;
      bottom: 0;
      content: '';
      height: 18px;
      left: 1px;
      position: absolute;
      -webkit-transition: 0.2s;
      transition: 0.2s;
      width: 18px;
      transform: translate(0, -5%);
    }
    &--round {
      border-radius: 34px;
    }
    &--round:before {
      border-radius: 50%;
    }
  }
  input:checked + &__slider {
    background-color: #70ffd4;
  }
  input:checked + &__slider:before {
    transform: translate(20px, -5%);
    left: 0;
  }
  input:disabled + &__slider {
    opacity: 0.6;
  }
}
</style>
